export var configParticlesChimneySmokeOverrides = {
    simpleHouse1: {
        x: 5,
        y: 65,
    },
    simpleHouse2: {
        x: 4,
        y: 65,
    },
    simpleHouse3: {
        x: 4,
        y: 65,
    },
    simpleHouse4: {
        x: 3,
        y: 0,
    },
    simpleHouse5: {
        x: 6,
        y: -3,
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/particles/configParticlesChimneySmokeOverrides.ts
// module id = 2193
// module chunks = 3